import { FormattedMessage } from 'react-intl'

export default function ContinueButtonStep2({ onClick, disabled, selectedTrip }) {
  return (
    <div className='btn-wrap'>
      { selectedTrip.freeCancellationDays && (
        <div className='benefits'>
          <p className='benefit' ng-show='::ctrl.selectedTrip[0].freeCancellationDays'>
            <i className='font-icons ok-icon-new' />
            <FormattedMessage id='48h' defaultMessage='48h free cancellation period' />
          </p>
        </div>
      ) }

      <div className='wrapper'>
        <button
          className='btn-red'
          onClick={onClick}
          disabled={disabled}>
          <FormattedMessage id='continue_to_step3' defaultMessage='CONTINUE TO STEP 3' />
          <i className='tooltip fade-onload'>
            <FormattedMessage id='select_guests'
              defaultMessage='Please select the number of guests you want to book using the + / - buttons above' />
          </i>
        </button>
        <p className='note'>
          <FormattedMessage id='dont_worry' defaultMessage='Don`t worry - you won`t be charged yet' />
        </p>
      </div>
    </div>
  )
}
